import { MESApiService } from "@dexteel/mesf-core";

export const getGrades = async (onlyEnabled?: boolean) => {
  const apiService = new MESApiService();
  const parameters = [];
  parameters.push({ name: "OnlyEnabled", value: onlyEnabled ? true : false });

  return await apiService.callV2("[STEEL].[GetGrades]", parameters);
};
